var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notifications-item",class:{ new: _vm.isNew },on:{"click":_vm.handleClick}},[_c('p',{staticClass:"notifications-item__description mb-2"},[_vm._v("\n    "+_vm._s(_vm.description)+"\n  ")]),_vm._v(" "),_c('p',{staticClass:"notifications-item__date mb-0"},[_vm._v("\n    "+_vm._s(_vm.format(_vm.meta.created_at))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }